import Vue from 'vue'
import Vuex from 'vuex'
import videosService, { deletePersonVideo } from '../api/videos'

Vue.use(Vuex)

const initialState = {
  personVideos: {},
  currentPersonVideo: null,
  videosOrder: []
}

const getters = {
  personVideos(state) {
    return state.personVideos
  },
  currentPersonVideo(state) {
    return state.currentPersonVideo
  },
  videosOrder(state) {
    return state.videosOrder
  }
}

export const mutations = {
  setVideoOrder(state, payload) {
    state.videosOrder = payload
  }
}

export const actions = {
  async saveVideosOrder(context, payload) {
    try {
      const response = await videosService.saveVideosOrder(payload);
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getVideosOrder(context, payload) {
    try {
      const response = await videosService.getVideosOrder(payload);
      context.state.videosOrder = response.data;
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getPersonVideos(context, payload) {
    try {
      const response = await videosService.getPersonVideos(payload);
      context.state.personVideos = response.data
      return Promise.resolve();
    } catch (error) {
      const errorMessage = context.rootState.langObj.response.error[error.response.data] || context.rootState.langObj.response.error.somethingWentWrong;
      context.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true });
      return Promise.reject(error);
    }
  },
  async getPersonVideoById(context, payload) {
    try {
      const response = await videosService.getPersonVideoById(payload);
      context.state.currentPersonVideo =
        response.data.video
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async updateVideoDetails(context, payload) {
    try {
      const response = await videosService.updateVideoDetails(payload);
      context.commit('toast', { message: context.rootState.langObj.response.success.changed, color: 'black' }, { root: true })
      return Promise.resolve();
    } catch (error) {
      context.commit('toast', { message: context.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  
  async deletePersonVideo(context, payload) {
    try {
      const response = await videosService.deletePersonVideo(payload);
      context.commit('toast', { message: context.rootState.langObj.response.success.deleteVideo, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      context.commit('toast', { message: context.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  }
}

export const state = { ...initialState }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
